import type {
  CreateAccountRequest,
  CreateAccountResponse,
  ErrorResponse,
} from '../types/api';

const API_BASE_URL = 'https://api.flow.cf-fp.me';

/**
 * Creates a new account via the API
 */
export async function createAccount(
  data: CreateAccountRequest
): Promise<CreateAccountResponse | ErrorResponse> {
  try {
    const response = await fetch(`${API_BASE_URL}/api/v1/create-account`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(data),
    });

    const result = await response.json();

    // If status is not 200, treat as error (even if 200 with error object)
    if (response.status !== 200) {
      return result as ErrorResponse;
    }

    // Check if response has error property
    if ('error' in result) {
      return result as ErrorResponse;
    }

    // Success response
    return result as CreateAccountResponse;
  } catch (error) {
    // Network or other errors
    return {
      error: {
        code: 'NETWORK_ERROR',
        message: 'Failed to connect to the server. Please try again later.',
      },
    };
  }
}

